import React from "react";
import { Box, Typography } from "@mui/material";
import { TalentExperienceData } from "@/cards/common/types";
import useThemeStore from "@/shared/stores/useThemeStore";

interface SingleImageDisplayProps {
  data?: TalentExperienceData;
}

const SingleImageDisplay: React.FC<SingleImageDisplayProps> = ({
  data = {},
}) => {
  const { darkMode } = useThemeStore();
  if (!data.image) return null;

  const textPrimary = darkMode ? "var(--neutralWhite)" : "var(--neutral-900)";
  const textSecondary = darkMode ? "var(--neutral-300)" : "var(--neutral-600)";

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        p: 3,
        gap: 2,
      }}
    >
      {data.image.imageUrl && (
        <Box
          sx={{
            width: "100%",
            flex: 1,
            borderRadius: 2,
            overflow: "hidden",
            bgcolor: darkMode ? "var(--neutral-800)" : "var(--neutral-100)",
          }}
        >
          <img
            src={data.image.imageUrl}
            alt={data.image.title || "Image"}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      )}
      {data.image.title && (
        <Typography
          variant="h6"
          sx={{
            color: textPrimary,
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          {data.image.title}
        </Typography>
      )}
      {data.image.description && (
        <Typography
          variant="body2"
          sx={{
            color: textSecondary,
            textAlign: "center",
          }}
        >
          {data.image.description}
        </Typography>
      )}
    </Box>
  );
};

export default SingleImageDisplay;
